module.exports = __webpack_public_path__ + "static/receiver-2-logo@2x-152eea3d2a3d283e904750e4af11b1c4.png";